import InputTextComp from "@components/UI/InputText/Index.jsx";
import ButtonComp from "@components/UI/Button/Index.jsx";
import SelectOptionComp from "@components/UI/SelectOption/Index.jsx"
import { useFetchDataUnidades } from "@hooks/api/Unidade/useFetchDataUnidades";
import { useEffect, useState } from "react";
import PerfilRadioFilter from "@components/Usuario/PerfilRadioFilter/Index";

// Valores iniciais alinhados com os filtros disponíveis
const initialValues = {
    nome: "",
    numeroSolicitacao: "",
    nomeUnidadeGerencia: "",
    perfil: ""
};

const Filter = ({ setFilters }) => {
    const [tempValues, setTempValues] = useState(initialValues);
    const { unitOptions, unitLoading, fetchUnits } = useFetchDataUnidades();

    useEffect(() => {
        fetchUnits();
    }, []);

    // Atualização de campos
    const handleTempChange = (field, value) => {
        setTempValues(prev => ({ ...prev, [field]: value }));
    };

    // Máscara para o Nº da Solicitação
    const handleSolicitacaoInput = e => {
        const value = e.target.value.replace(/-/g, '').toUpperCase();
        const formatted = [
            value.slice(0, 3),
            value.slice(3, 6),
            value.slice(6, 10),
            value.slice(10, 13),
        ].filter(Boolean).join('-');
        handleTempChange("numeroSolicitacao", formatted);
    };

    // Aplicar filtros (envia valores prontos para API)
    const handleSearch = (e) => {
        e.preventDefault();

        setFilters({
            nome: tempValues.nome,
            numeroSolicitacao: tempValues.numeroSolicitacao,
            nomeUnidadeGerencia: tempValues.nomeUnidadeGerencia?.label || "",
            perfil: tempValues.perfil,
        });
    };

    // Limpa filtros
    const handleClearFilter = () => {
        setTempValues(initialValues);
        setFilters(initialValues);
    };

    return (
        <form onSubmit={handleSearch} className="form">
            <div className="row py-3">

                <div className="col-4 md-4">
                    <PerfilRadioFilter
                        value={tempValues.perfil}
                        onChange={selected => handleTempChange("perfil", selected)}
                    />
                </div>

                <div className="col-8 col-md-8 px-0">

                    <InputTextComp
                        label={"Nome do Usuário"}
                        hoverMessage="Nome do Usuário"
                        value={tempValues.nome}
                        onChange={e => handleTempChange("nome", e.target.value)}
                        placeholder="Preencher com o nome do usuário"
                        maxLength={150}
                    />

                    <InputTextComp
                        label="Nº da Solicitação"
                        hoverMessage="Número da Solicitação"
                        value={tempValues.numeroSolicitacao}
                        onChange={handleSolicitacaoInput}
                        placeholder="Preencher com o número da solicitação."
                        maxLength={16}
                    />

                    <SelectOptionComp
                        label="Unidade/Gerência"
                        options={unitOptions}
                        value={tempValues.nomeUnidadeGerencia}
                        onChange={val => handleTempChange("nomeUnidadeGerencia", val)}
                        placeholder="Selecionar uma unidade/gerência"
                        hoverMessage="Nome da Unidade/Gerência"
                        isLoading={unitLoading}
                        isClearable
                    />

                </div>

                <div className="col-12 col-md-12 d-flex flex-wrap justify-content-end mt-4">
                    <ButtonComp
                        type="submit"
                        title="Buscar dados"
                        buttonColor="#2b97be"
                        classnameIcon="fa-solid fa-filter"
                        hoverMessage="Botão para aplicar o filtro da consulta"
                    />
                    <ButtonComp
                        type="button"
                        onClick={handleClearFilter}
                        title="Limpar filtro"
                        buttonColor="#125578"
                        classnameIcon="fa-regular fa-circle-xmark"
                        hoverMessage="Botão para limpar os campos de filtros preenchidos"
                    />
                </div>

            </div>
        </form>
    );
}

export default Filter;